import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper as SwiperI } from "swiper/types";
import "swiper/css";
import MaxWidthWrapper from "../common/MaxWidthWrapper";
import SecondaryWidthWrapper from "../common/SecondaryWidthWrapper";
import TitleSummary from "./TitleSummary";
import { Link } from "gatsby";
import Slugs from "../../util/slugs";
import ResourceCard from "./ResourceCard";
import { NextButton, PrevButton } from "../common/CarouseButtons";
import { IoArrowForwardCircleOutline } from "react-icons/io5";

interface Props {
  title: string;
  subtitle: string;
  blogs: any[];
  exploreClassName?: string;
}

const Explore: React.FC<Props> = ({
  title,
  subtitle,
  blogs,
  exploreClassName,
}) => {
  const [swiper, setSwiper] = useState<SwiperI | null>(null);

  return (
    <section className={`bg-gray-100 ${exploreClassName}`}>
      {/* <div className="relative">
        <div className="fadeInSectionGray py-10 absolute -top-14 left-0 w-full"></div>
      </div> */}
      <MaxWidthWrapper>
        <SecondaryWidthWrapper>
          <div className="pt-10 pb-20">
            <TitleSummary
              summary={subtitle}
              titleClassName="text-center lg:text-left"
              summaryClassName="text-center lg:text-left"
              title={title}
              action={
                <Link to={`/${Slugs.page.BLOG_PAGE}`}>
                  {/* @ts-ignore */}
                  <button
                    className="flex h-12 items-center justify-center gap-2 rounded-full bg-primary px-7 py-3 text-sm font-semibold text-white hover:bg-green-600 disabled:pointer-events-none disabled:opacity-50"
                    disabled={false} // set to true if loading
                  >
                    View All Articles
                    <span>
                      {/* @ts-ignore */}
                      <IoArrowForwardCircleOutline size={25} />
                    </span>
                  </button>
                </Link>
              }
            />

            <div className="mt-14 hidden grid-cols-1 gap-x-4 gap-y-7 lg:grid lg:grid-cols-2">
              {blogs?.slice(0, 4).map((item) => {
                return (
                  <ResourceCard
                    key={item.id}
                    thumbnail={
                      item?.attributes.thumbnail?.media?.data?.[0]?.attributes
                        ?.url
                    }
                    summary={item?.attributes?.summary}
                    title={item?.attributes?.title}
                    slug={item?.attributes?.slug}
                    type="blog"
                  />
                );
              })}
            </div>

            <div className="mt-12 gap-7 lg:hidden">
              <Swiper loop navigation onSwiper={(_s) => setSwiper(_s)}>
                {blogs?.slice(0, 4).map((item) => (
                  <SwiperSlide>
                    <ResourceCard
                      key={item?.id}
                      thumbnail={
                        item?.attributes?.thumbnail?.media?.data?.[0]?.attributes
                          ?.url
                      }
                      summary={item?.attributes?.summary}
                      title={item?.attributes?.title}
                      slug={item?.attributes?.slug}
                      type="blog"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="mt-7 flex justify-end gap-3">
                <PrevButton onClick={() => swiper?.slidePrev()} />
                <NextButton onClick={() => swiper?.slideNext()} />
              </div>
            </div>
          </div>
        </SecondaryWidthWrapper>
      </MaxWidthWrapper>
    </section>
  );
};

export default Explore;
